import React, { useEffect, useRef } from 'react'
import { Form } from 'antd'
import { Formik } from 'formik'
import { object, number } from 'yup'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { SelectValue } from 'antd/lib/select'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { getPolicy } from 'src/core/store/ducks/me/actions'
import { Modal } from 'src/components/Ant'
import { SelectResource } from 'src/components/Formik'

interface Params {
  reason_id: string
}

interface Props {
  toggle(): void
  visible: boolean
}

function ReasonModal({
  match: {
    params: { reason_id }
  },
  history,
  toggle,
  visible
}: Props & RouteComponentProps<Params>) {
  const dispatch = useDispatch()
  const { me } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))
  const refFormik = useRef(null)

  useEffect(() => {
    if (visible) dispatch(getPolicy())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <Modal
      destroyOnClose
      okButtonProps={{
        //@ts-ignore
        'data-test-id': 'dashboard-side-new-request-reasons-submit',
        loading: me.loading.policy
      }}
      okText="common.actions.continue"
      onCancel={() => toggle()}
      onOk={() => refFormik.current.submitForm()}
      title="web.new-request.modal-reason.title"
      visible={visible}
      width={320}
    >
      <Formik
        ref={refFormik}
        initialValues={{
          tmp_reason_id: reason_id
        }}
        onSubmit={values => {
          toggle()
          history.replace(`/my-requests`)
          history.push(`/my-requests/create/reason/${values.tmp_reason_id}`)
        }}
        validationSchema={object().shape({
          tmp_reason_id: number()
            .required('common.required')
            .typeError('common.required')
        })}
        render={formikProps => (
          <Form onSubmit={formikProps.handleSubmit}>
            <SelectResource
              autoFocus
              formikProps={formikProps}
              keyLabel="name"
              keyValue="reason_id"
              label="web.setup.form.reason.title"
              name="tmp_reason_id"
              onChange={(value: SelectValue) => {
                formikProps.setFieldValue('tmp_reason_id', value)
              }}
              organization_id={me.organization.organization_id}
              placeholder="web.setup.form.reason.placeholder"
              resource="reasons"
            />
          </Form>
        )}
      />
    </Modal>
  )
}

export default withRouter(ReasonModal)
